import { render, staticRenderFns } from "./EditGallery.vue?vue&type=template&id=f9121b06&scoped=true"
import script from "./EditGallery.vue?vue&type=script&lang=js"
export * from "./EditGallery.vue?vue&type=script&lang=js"
import style0 from "./EditGallery.vue?vue&type=style&index=0&id=f9121b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9121b06",
  null
  
)

export default component.exports